import Container from 'react-bootstrap/Container';
import { useAuthenticator } from '@aws-amplify/ui-react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import React from "react";
import UserNotificationBell from '../components/UserNotificationBell';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import metrologo from '../images/mhb-site-logoSmall.png';
import metroham from '../images/icons8-menu-26 white.png';

export const LoggedInNav = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const { push } = useHistory();
  const [showModal, setShowModal] = React.useState(false);
  const onButtonClick = async () => {
    await Auth.signOut();
    alert('Signed out');
    push('/public');
  };
    
  if (user) {
    return (
      <div className='App'>
        <Navbar expand='lg' className='navContainer2'>
          <Container className='containerNav'>
            <Navbar.Toggle />
            <Navbar.Collapse style={{ columnGap: '16px'}}>
              <Nav className=''>
                <Nav.Link
                  href="#"
                  className='m_links nav-link'
                  onClick={e => { e.preventDefault(); setShowModal(true); }}
                >
                  <img src={metroham} className='mham' alt='mhb-hamburger.png' />
                </Nav.Link>
                <Nav.Link href='/home' className='m_links nav-link'><img src={metrologo} className='mLogo2' alt='mhb-site-logoSmall.png' /></Nav.Link>             
                <Nav.Link href='/home'><h6 className='m_hTitle'>Property Manager Portal</h6></Nav.Link>
                <Nav.Link href='/home' className='m_links'>PORTAL DASHBOARD</Nav.Link>
                <Nav.Link href='/payments' className='m_links'>PAYMENTS</Nav.Link>
                <NavDropdown title='OPTIONS' className='m_links nav-link'>
                  <NavDropdown.Item className='m_links' href='/main'>MESSAGES & ALERTS</NavDropdown.Item>
                  <NavDropdown.Item className='m_links' href='/documents'>MY DOCUMENTS</NavDropdown.Item>
                  <NavDropdown.Item className='m_links' href='/settings'>SETTINGS</NavDropdown.Item>
                  <NavDropdown.Item className='m_links' target='_blank' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'>UPDATE DIRECT DEPOSIT</NavDropdown.Item>
                  <NavDropdown.Item className='m_links' href='/faq'>FREQUENTLY ASKED QUESTIONS</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={onButtonClick}>
                    SIGN OUT
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <Nav className="ms-auto">
                <UserNotificationBell />
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>MHB Support</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3 className='text-center'>Helpful Links</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Button variant="primary buttons" target='_blank' rel='noreferrer' href='https://metrohousingboston.zendesk.com/hc/en-us' >Leased Housing Help Center</Button>
              <Button variant="primary buttons" target='_blank' rel='noreferrer' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'>Update Direct Deposit</Button>
              <Button variant="primary buttons" href='/faq'>FAQ</Button>
              <Button variant="primary buttons" href='mailto:portalhelp@mbhp.org?subject=[Technical Support]'>Submit Ticket</Button>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary buttons" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  } else {
    return (
      <div className='App'>
        <Navbar expand='lg' className='navContainer2'>
          <Container className='containerNav'>
            <Navbar.Toggle />
            <Navbar.Collapse >
              <Nav className=''>
              <Nav.Link
                  href="#"
                  className='nav-link'
                  onClick={e => { e.preventDefault(); setShowModal(true); }}
                >
                  <img src={metroham} className='mham' alt='mhb-hamburger.png' />
                </Nav.Link>
              <Nav.Link href='/home' className='nav-link'><img src={metrologo} className='mLogo2' alt='mhb-site-logoSmall.png' /></Nav.Link>             
              <Nav.Link href='/home'><h6 className='m_hTitle'>Property Manager Portal</h6></Nav.Link>
              <Nav.Link className='registerBTN' href='/register'>REGISTER TODAY</Nav.Link>
              <Nav.Link href='/home'>PORTAL DASHBOARD</Nav.Link>
                <NavDropdown title='FAQ' className='m_hTitle2 nav-link'>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href='/login'>
                    LOG IN
                  </NavDropdown.Item>
                  <NavDropdown.Item href='/faq'>FREQUENTLY ASKED QUESTIONS</NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>MHB Support</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3 className='text-center'>Helpful Links</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Button variant="primary buttons" target='_blank' rel='noreferrer' href='https://metrohousingboston.zendesk.com/hc/en-us' >Leased Housing Help Center</Button>
              <Button variant="primary buttons" target='_blank' rel='noreferrer' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'>Update Direct Deposit</Button>
              <Button variant="primary buttons" href='/faq'>FAQ</Button>
              <Button variant="primary buttons" href='mailto:portalhelp@mbhp.org?subject=[Technical Support]'>Submit Ticket</Button>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary buttons" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    ) 
  }
}

export default LoggedInNav;